const customerUtils = {
    isAoCustomer(customer) {
        return (customer?.group >= 1800 && customer?.group <= 1899) || (customer?.customerGroup >= 1800 && customer?.customerGroup <= 1899);
    },
    
    isPartnerCustomer(customer) {
        return (customer?.type === 4 || customer?.type === 5)
            || (customer?.group === 3000 || customer?.group === 3020 || customer?.group === 3050) 
            || (customer?.customerGroup === 3000 || customer?.customerGroup === 3020 || customer?.customerGroup === 3050);
    },
    isResellerCustomer(customer) {
        const isResellerType = (cust) => cust && ((cust.customerGroup >= 3000 && cust.customerGroup <= 3999) || cust.type === 2);

        if (isResellerType(customer.vbCustomer)) return true;
        if (isResellerType(customer.vossCustomer)) return true;

        return false;
    },
};

export default customerUtils;
